import { useState } from 'react';
import { Modal, Button, Group, Title } from '@mantine/core';
import LoginForm from './Login';

function LoginModal({ setIsAuthenticated }: any) {
  const [opened, setOpened] = useState(false);

  return (
    <>
      <Modal
        opened={opened}
        onClose={() => setOpened(false)}
        title={<Title order={6}>Login</Title>}>
        <LoginForm setIsAuthenticated={setIsAuthenticated} />
      </Modal>

      <Group position="center">
        <Button variant="gradient" compact onClick={() => setOpened(true)}>
          Login
        </Button>
      </Group>
    </>
  );
}

export default LoginModal;
